function initAccessibleFilter({
  container = '.filter-contain',
  itemSelector = '.prod-card',
  filters = [],
  summaryTarget = '#a11y-filter-status',
  clearOnToggle = false,
  toggleButton = '.filter-toggle',
  filterPanel = '.press-on-filter'
}) {
  const $container = $(container);
  const $items = $(itemSelector);
  const $summary = $(summaryTarget);
  const $toggle = $container.find(toggleButton);
  const $panel = $container.find(filterPanel);

  if ($toggle.length && $panel.length) {
    $toggle.attr('role', 'button').attr('aria-expanded', 'false').attr('tabindex', 0);

    $toggle.on('click keypress', function (e) {
      if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
        const expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded);
        $panel.toggle();
      }
    });
  }

  filters.forEach(f => {
    $container.on('change', f.selector, applyFilterLogic);
  });

  function applyFilterLogic() {
    $items.show();
    filters.forEach(f => {
      const $checked = $container.find(`${f.selector}:checked`);
      if ($checked.length === 0) return;

      const selected = $checked.map(function () {
        return $(this).data('id');
      }).get();

      $items.filter(function () {
        const val = $(this).data(f.dataAttr);
        return !selected.includes(val);
      }).hide();
    });

    announceFilters();
  }

  function announceFilters() {
    const visibleCount = $items.filter(':visible').length;

    const descriptions = filters.map(f => {
      const $checked = $container.find(`${f.selector}:checked`);
      if ($checked.length === 0) return null;
      const labels = $checked.map(function () {
        return $(this).siblings('label').text().trim();
      }).get();
      return `${f.label}: ${labels.join(', ')}`;
    }).filter(Boolean);

    const summary = descriptions.length
      ? `Filters applied: ${descriptions.join('. ')}.`
      : 'No filters applied.';

    const result = visibleCount === 0
      ? 'No products match your filter selections.'
      : `${visibleCount} product${visibleCount > 1 ? 's' : ''} shown.`;

    $summary.text('');
    setTimeout(() => $summary.text(`${summary} ${result}`), 20);
  }

  // Init on load
  applyFilterLogic();
}
